import { CaseLawDetailsPage } from "@/pages/caselaw-details";
import { createFileRoute } from "@tanstack/react-router";
import { searchParams } from "@/pages/caselaw-details/model/search-params";

export const Route = createFileRoute(
  "/_authed/$companySlug/caselaw/$caselawId/",
)({
  component: CaseLawDetailsPage,
  validateSearch: searchParams,
});
